import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import Button from '../Button';
import { I18n } from 'react-redux-i18n';

const PopupContainer = styled.div`
  display: ${(props) => (props.open ? 'flex' : 'none')};
  position: fixed;
  animation: opacity 0.5s;

  z-index: 10;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;

  .backFilter {
    background-color: ${(props) => props.theme.colors.dark};
    opacity: 0.3;
    width: 100%;
    height: 100%;
    position: fixed;
  }

  .popupContainer {
    background-color: white;
    width: ${(props) => (props.size ? props.size.width : '50vw')};
    min-width: ${(props) => (props.size ? props.size.width : '600px')};
    min-height: ${(props) => (props.size ? props.size.height : '400px')};
    z-index: 20;
    opacity: 1;
    border-radius: 4px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      width: calc(100vw - 32px);
      min-width: 0;
    }
  }

  .popupHeader {
    width: 100%;
    height: 60px;
    display: flex;
    flex: 0;
    flex-direction: row;
    align-items: center;
    background-color: ${(props) => props.theme.colors.dark};
  }

  .iconContainer {
    margin-left: 30px;
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .popupTitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 18px;
    font-weight: 400;
    color: white;
    margin-left: 18px;
    text-transform: uppercase;
  }

  .closeIconContainer {
    margin-left: auto;
    margin-right: 30px;
    border-radius: 50%;
    border: 1px solid white;
    color: white;
    width: 20px;
    height: 20px;
  }

  .closeIconContainer:hover {
    cursor: pointer;
  }

  .popupContentContainer {
    padding: 20px;
    height: auto;
    overflow-y: auto;
    display: flex;
    flex: 1;
    flex-direction: column;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      padding: 16px;
    }
  }

  .popupBottomContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      flex-direction: column;
      gap: 16px;
    }
  }

  .popupBottomContainer > div {
    width: 100px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      width: 100%;
    }
  }
`;

function renderBottomContainer({
  onCancel,
  onClose,
  cancelLabel,
  okLabel,
  disableOk,
  onOk
}) {
  return (
    <div className="popupBottomContainer">
      {(onCancel || onClose) && (
        <Button
          label={cancelLabel ? cancelLabel : I18n.t('cancel')}
          color="white"
          textColor="black"
          width="100%"
          border="0.8px black solid"
          textTransform="normal"
          fontFamily="SFCompactText"
          onClick={onCancel ? () => onCancel() : () => onClose()}
        />
      )}
      <Button
        label={okLabel ? okLabel : I18n.t('validate')}
        textTransform="normal"
        width="100%"
        disabled={disableOk}
        onClick={() => onOk()}
      />
    </div>
  );
}

function Popup(props) {
  const { open, onClose, icon, title, children, blockClose, size, hideButton } =
    props;
  return (
    <PopupContainer open={open} size={size}>
      <div className="backFilter" onClick={() => onClose()} />
      <div className="popupContainer">
        <div className="popupHeader">
          {icon && (
            <div className="iconContainer">
              <Icon icon={icon} />
            </div>
          )}
          <h1 className="popupTitle">{title}</h1>
          {!blockClose && (
            <div className="closeIconContainer" onClick={() => onClose()}>
              <Icon icon="close" />
            </div>
          )}
        </div>
        <div className="popupContentContainer">
          {children}
          {hideButton ? null : renderBottomContainer(props)}
        </div>
      </div>
    </PopupContainer>
  );
}

export default Popup;
